import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-with-header',
  templateUrl: './component-with-header.component.html',
  styleUrls: ['./component-with-header.component.css']
})
export class ComponentWithHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
